// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_n9-5";
export var filledCircle = "_n9-4";
export var historyEntry = "_n9-3";
export var messageSideLeft = "_n9-1";
export var messageSideRight = "_n9-2";
export var orderTrackingCarouselWrapper = "_n9-6";
export var orderTrackingInfoContainer = "_n9-0";